import React, { useContext } from "react";
import { Grid, Switch, FormControl, FormControlLabel, FormGroup, Select, MenuItem, InputLabel, TextField, Typography } from "@material-ui/core";
import "./style.css";
import ItemPedidoConfirmado from "./ItemPedidoConfirmado";
import ItemCompletado from "./ItemCompletado";
import { get, post } from "../../api/axios";
import Audio from "./Audio";
import Disponibilidad from "../dashboard/Disponibilidad";
import NumerosDeHoy from './NumerosDeHoy';
import { StoreContext } from "./pedidosContext/Store";
import { openAlert } from 'simple-react-alert';
import moment from 'moment';
import echo from "../../echo";

const channel = echo.channel(process.env.REACT_APP_LARAVEL_ECHO_CHANNEL);

const TIMEFORMAT = "YYYY-MM-DD HH:mm:ss";
const Pedidos = () => {
    const { state, dispatch } = useContext(StoreContext)
    const [nuevos, setNuevos] = React.useState([]);
    const [confirmados, setConfirmados] = React.useState([]);
    const [enEntrega, setEnEntrega] = React.useState([]);
    const [afuera, setAfuera] = React.useState([]);
    const [completados, setCompletados] = React.useState([]);
    const [cancelados, setCancelados] = React.useState([]);
    const [cadetes, setCadetes] = React.useState([]);
    const [programados, setProgramados] = React.useState([]);
    const [numCompletados, setNumCompletados] = React.useState(0);
    const [numCancelados, setNumCancelados] = React.useState(0);
    const [numProgramados, setNumProgramados] = React.useState(0);
    const [flag, setFlag] = React.useState(true);
    const [actualizar, setActualizar] = React.useState(true);
    const [notify, setNotify] = React.useState(false);
    const [selectedCity, setSelectedCity] = React.useState("");
    const [showOnlyWithoutCadete, setShowOnlyWithoutCadete] = React.useState(false);
    const [ciudades, setCiudades] = React.useState([]);
    const [nuevosCol, setNuevosCol] = React.useState(3);
    const [confirmadosCol, setConfirmadosCol] = React.useState(4);

    React.useEffect(() => {
        get("/cadetes/disponibles").then(response => {
            setCadetes(response.data);
            setActualizar(true);
        });

        get("/ciudades").then(response => {
            setCiudades(response.data?.filter((ciudad) => !ciudad.nombre.includes('oculto') && ciudad.estado !== 'cerrado'));
        });

        channel.listen(process.env.REACT_APP_ECHO_DASHBOARD_EVENTS, (data) => {
            if (data.message === "nuevo" || data.message === 'confirmado' || data.message === 'pago realizado' || data.message === 'cancelado' || data.message === 'rechazado' || data.message === 'timer') {
                setActualizar(true);
                dispatch({
                    type: 'PULL',
                    pull: 1
                })
            }
            if (data.message === 'cadete-disponible') {
                pedirCadetes();
            }
            if (data.message == 'estado') {
                setActualizar(true);
                dispatch({
                    type: 'PULL',
                    pull: 1
                })
            }
            if (data.message == 'cancelado') {
                openAlert({
                    message: "pedido con id: " + data.value.pedido_id + " fue cancelado",
                    type: "info",
                    duration: 10000
                });
                setActualizar(true);
                dispatch({
                    type: 'PULL',
                    pull: 1
                })
            }
             if (data.message === "nuevo") {
                setNotify(true);
             }
            if (data.message == 'estado' && data.value.viejo === 'Búsqueda') {
                setActualizar(true);
                dispatch({
                    type: 'PULL',
                    pull: 1
                })
            }
            if (data.message == 'cadete-set' && data.value.viejo !== null) {
                setActualizar(true);
                dispatch({
                    type: 'PULL',
                    pull: 1
                })
                pedirCadetes();
            }
            if (data.message == 'reasignado') {
                openAlert({
                    message: "pedido con id: " + data.value + " fue reasignado",
                    type: "info",
                    duration: 10000
                });
                setActualizar(true);
                dispatch({
                    type: 'PULL',
                    pull: 1
                })
            }
        });
    }, []);

    React.useEffect(() => {
        if (state.dirty && actualizar && flag) {
            dispatch({
                type: 'PULL',
                pull: 1
            });
        }
        else actualizar && flag && pedirPedidos();
    }, [actualizar, flag])

    React.useEffect(() => {
        !state.dirty && state.pull && flag && pedirPedidos();
    }, [state.pull, state.dirty])

    const pedirPedidos = () => {
        if (flag) {
            let date = moment().format("YYYY-MM-DD");
            get("/pedidos?fecha=" + date).then(response => {
                setPedidos(response.data);
                dispatch({
                    type: "PULL",
                    pull: 0
                })
            });
            setActualizar(false);
        }
    };

    const dispatchDirty = (value) => {
        dispatch({
            type: 'MODIFYING',
            dirty: value
        });
    }

    const pedirCadetes = () => {
        get("/cadetes/disponibles").then(response => {
            setCadetes(response.data);
        });
    }

    const setPedidos = pedidos => {
        let nuevos = [];
        let confirmados = [];
        let enEntrega = [];
        let completados = [];
        let afuera = [];
        let cancelados = [];
        let programados = [];
        let numProgramados = 0;
        const horaActual = moment().hour();
        pedidos.map(pedido => {
            if (pedido.hora !== 'Inmediata' && (pedido.estado === 'Recibido') && pedido.estado !== 'Cancelado') {
                programados.push(pedido);
                numProgramados++;
                //let horaPedido = moment(pedido.hora, "HH:mm");
                /*if (horaPedido.hour() - horaActual <= 1) {
                    numProgramados++;
                }*/
            }
            else {
                switch (pedido.estado) {
                    case "Recibido": {
                        nuevos.push(pedido);
                        break;
                    }
                    case "Búsqueda": {
                        confirmados.push(pedido);
                        break;
                    }
                    case "En Camino": {
                        enEntrega.push(pedido);
                        break;
                    }
                    case "Finalizado": {
                        completados.push(pedido);
                        break;
                    }
                    case "Afuera": {
                        afuera.push(pedido);
                        break;
                    }
                    case "Cancelado": {
                        cancelados.push(pedido);
                    }
                    default: {
                        break;
                    }
                }

                return 0;
            }
        });

        setNuevos(nuevos);
        setConfirmados(confirmados);
        setEnEntrega(enEntrega);
        completados.sort((a, b) => {
            let d1 = new Date(a.created_at);
            let d2 = new Date(b.created_at);
            return d2 - d1;
        });
        setNumCompletados(completados.length);
        setNumCancelados(cancelados.length);
        cancelados.sort((a, b) => {
            let d1 = new Date(a.updated_at);
            let d2 = new Date(b.updated_at);
            return d2 - d1;
        })
        setCancelados(cancelados);
        setCompletados(completados);
        setAfuera(afuera);
        setNumProgramados(numProgramados);
        setProgramados(programados);
        if (nuevos.length > 0) {
            return <Audio />;
        }
    };

    const cancelarPedido = (id, razon, setShowModal) => {
        post("/pedidos/" + id + "/cancelar", { razon: razon }).then(() => {
            dispatch({
                action: "PULL",
                pull: 1
            });

            openAlert({
                message: "pedido eliminado con exito",
                type: "success"
            });
            setShowModal(false);
        }).catch(openAlert({
            message: "El pedido no pudo ser eliminado",
            type: "error"
        }));
    };

    const setTimestamp = (id, timestamp) => {
        let estimatedTime = moment().utc(true).add(timestamp, "minute");
        post("/pedidos/" + id + "/timer", { timer: estimatedTime.format(TIMEFORMAT) }).then(() => {
            dispatch({
                action: "PULL",
                pull: 1
            })
        })
    };

    const modificarPedido = (body) => {
        post("/pedidos/cambio", body).then(() => {
            dispatch({
                action: "PULL",
                pull: 1
            })
        });
    };

    const estaEnProgramado = (pedido) => {
        return programados.find(prog => prog.id === pedido.id);
    }

    const aConfirmado = pedido => {
        dispatchDirty(1);
        let programado = estaEnProgramado(pedido);
        let endpoint = "/pedidos/" + pedido.id + "/estado";
        post(endpoint, { estado: "Búsqueda" }).then(response => {
            setConfirmados([...confirmados, pedido]);
            if (programado) {
                let temp = programados.filter(nuevo => {
                    return nuevo.id !== pedido.id;
                });
                setProgramados([...temp]);
            }
            else {
                let temp = nuevos.filter(nuevo => {
                    return nuevo.id !== pedido.id;
                });
                setNuevos([...temp]);
            }
            dispatchDirty(0);
        });
    };

    const aEntrega = pedido => {
        dispatchDirty(1);
        let endpoint = "/pedidos/" + pedido.id + "/estado";
        if(pedido.tipo === "TakeAway") {
            post(endpoint, { estado: "Finalizado" }).then(response => {
                setCompletados([...completados, pedido]);
                let tempAfuera = afuera.filter(nuevo => {
                    return nuevo.id !== pedido.id;
                });
                setAfuera([...tempAfuera]);
                dispatchDirty(0);
                // setProcesandoEstado(false);
            });
        } else if (pedido.cadete) {
            post(endpoint, { estado: "En Camino" }).then(response => {
                setEnEntrega([...enEntrega, pedido]);
                let tempConfirmados = confirmados.filter(nuevo => {
                    return nuevo.id !== pedido.id;
                });
                setConfirmados([...tempConfirmados]);
                dispatchDirty(0);
            });
        }
    };
    const aAfuera = pedido => {
        dispatchDirty(1);
        let endpoint = "/pedidos/" + pedido.id + "/estado";
        post(endpoint, { estado: "Afuera" }).then(response => {
            setAfuera([...afuera, pedido]);
            let tempEntrega = enEntrega.filter(nuevo => {
                return nuevo.id !== pedido.id;
            });
            setEnEntrega([...tempEntrega]);
            dispatchDirty(0);
        });
    };
    const aCompletados = pedido => {
        dispatchDirty(1);
        let endpoint = "/pedidos/" + pedido.id + "/estado";
        post(endpoint, { estado: "Finalizado" }).then(response => {
            setCompletados([...completados, pedido]);
            let tempAfuera = afuera.filter(nuevo => {
                return nuevo.id !== pedido.id;
            });
            setAfuera([...tempAfuera]);
            dispatchDirty(0);
        });
    };

    const findCadete = (id, ciudad_id) => {
        let cadete = cadetes[ciudad_id].find(cadete => cadete.id === id);
        return cadete
    };
    const setCadete = (pedido, cadete_id) => {
        let cadeteNuevo = findCadete(cadete_id, pedido.ciudad_id);
        let endpoint = "/pedidos/" + pedido.id + "/cadete";
        post(endpoint, { cadete_id: cadete_id }).then(response => {
            let temp = nuevos.filter(nuevo => {
                if (pedido.id === nuevo.id) {
                    nuevo.cadete = cadeteNuevo;
                    return nuevo;
                } else {
                    return nuevo;
                }
            });
            setNuevos([...temp]);
            let temp2 = confirmados.filter(nuevo => {
                if (pedido.id === nuevo.id) {
                    nuevo.cadete = cadeteNuevo;
                    return nuevo;
                } else {
                    return nuevo;
                }
            });
            setConfirmados([...temp2]);
            let temp3 = programados.filter(nuevo => {
                if (pedido.id === nuevo.id) {
                    nuevo.cadete = cadeteNuevo;
                    return nuevo;
                } else {
                    return nuevo;
                }
            });
            setProgramados([...temp3]);
        });
    };

    // Filter function for pedidos (with cadete filter)
    const filterPedidos = (pedidosList) => {
        return pedidosList.filter(pedido => {
            const matchesCity = selectedCity === "" || String(pedido.ciudad_id) === String(selectedCity);
            const matchesCadete = !showOnlyWithoutCadete || pedido.confirmado === 0;
            return matchesCity && matchesCadete;
        });
    };

    // Filter function for city only (for completados, cancelados, programados)
    const filterByCity = (pedidosList) => {
        if (selectedCity === "") return pedidosList;
        return pedidosList.filter(pedido => String(pedido.ciudad_id) === String(selectedCity));
    };

    const filteredNuevos = filterPedidos(nuevos);
    const filteredConfirmados = filterPedidos(confirmados);
    const filteredProgramados = filterByCity(programados);
    const filteredCompletados = filterByCity(completados);
    const filteredCancelados = filterByCity(cancelados);
    return (
        <>
            <Audio active={notify} notify={setNotify}/>
            <Disponibilidad pedirPedidos={pedirPedidos} />
            <NumerosDeHoy completados={numCompletados} cancelados={numCancelados} programados={programados} />
            <div style={{ display: 'flex', alignItems: 'center', marginLeft: '177px', gap: '20px', flexWrap: 'wrap' }}>
                <FormControl component="fieldset">
                    <FormGroup aria-label="position" row>
                        <FormControlLabel
                            control={<Switch color="secondary" checked={flag} onChange={() => setFlag(!flag)} />}
                            label="Refresh automatizado"
                            labelPlacement="start"
                        />
                    </FormGroup>
                </FormControl>
                
                <FormControl style={{ minWidth: 150 }}>
                    <InputLabel id="city-filter-label">Ciudad</InputLabel>
                    <Select
                        labelId="city-filter-label"
                        value={selectedCity}
                        onChange={(e) => setSelectedCity(e.target.value)}
                    >
                        <MenuItem value="">Todas</MenuItem>
                        {ciudades.map(ciudad => (
                            <MenuItem key={ciudad.id} value={ciudad.id}>{ciudad.nombre}</MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <FormControl component="fieldset">
                    <FormGroup aria-label="position" row>
                        <FormControlLabel
                            control={
                                <Switch 
                                    color="secondary" 
                                    checked={showOnlyWithoutCadete} 
                                    onChange={() => setShowOnlyWithoutCadete(!showOnlyWithoutCadete)} 
                                />
                            }
                            label="Solo sin cadete"
                            labelPlacement="start"
                        />
                    </FormGroup>
                </FormControl>
                <Grid container columnSpacing={2} marginLeft={"10%"}>
                <Grid item xs={12}>
                <Typography>Cantidad de pedidos por sección (Maximo 12):</Typography>
                </Grid>
            <Grid item xs={6}>
                    <TextField label="Nuevos" value={nuevosCol} onChange={(e) => setNuevosCol(e.target.value)} />
                  <TextField label="Confirmados" value={confirmadosCol} onChange={(e) => setConfirmadosCol(e.target.value)} />
                </Grid>
            </Grid>
            </div>
            <div className="pedidosContainer">
                <Grid
                    container
                    spacing={2}
                    className={"gridPedidos"}
                    justify={"center"}
                >
                    <Grid item xs={4} className={"pedidosLabel"}>
                        <p>Nuevos: {filteredNuevos.length}</p>
                        <Grid container spacing={1}>
                            {filteredNuevos.map((pedido, key) => {
                                return (
                                    <Grid item xs={Math.floor(12 / Math.max(1, Math.floor(nuevosCol)))} key={key}>
                                        <ItemPedidoConfirmado
                                            pedido={pedido}
                                            className={'itemPedido'}
                                            setCadete={setCadete}
                                            cadetes={cadetes[pedido.ciudad_id]}
                                            cadete={pedido.cadete}
                                            avanzar={aConfirmado}
                                            setTimestamp={setTimestamp}
                                            modificarPedido={modificarPedido}
                                            cancelarPedido={cancelarPedido}
                                        />
                                    </Grid>
                                );
                            })}
                        </Grid>
                    </Grid>
                    <Grid item xs={8} className={"pedidosLabel"}>
                        <p>Confirmados: {filteredConfirmados.length}</p>
                        <Grid container spacing={1}>
                            {filteredConfirmados.map((pedido, key) => {
                                return (
                                    <Grid item xs={Math.floor(12 / Math.max(1, Math.floor(confirmadosCol)))} key={key}>
                                        <ItemPedidoConfirmado
                                            className={'itemConfirmado'}
                                            avanzar={aEntrega}
                                            pedido={pedido}
                                            setCadete={setCadete}
                                            cadetes={cadetes[pedido.ciudad_id]}
                                            cadete={pedido.cadete}
                                            setTimestamp={setTimestamp}
                                            modificarPedido={modificarPedido}
                                            cancelarPedido={cancelarPedido}
                                        />
                                    </Grid>
                                );
                            })}
                        </Grid>
                    </Grid>
                </Grid>
            </div>

            <Grid container className={'cardProgramados'} justify='flex-start' style={{ padding: '0 16px' }}>
                <Grid item xs={12}>
                    {/* Programados Section */}
                    <Grid container className={"pedidosLabel"} style={{ marginBottom: 16 }}>
                        <Grid item xs={12}>
                            <p>Programados: {filteredProgramados.length}</p>
                        </Grid>
                        <Grid container spacing={1}>
                            {filteredProgramados.map((pedido, key) => (
                                <Grid item xs={2} key={key}>
                                    <ItemPedidoConfirmado
                                        pedido={pedido}
                                        className={'itemPedido'}
                                        setCadete={setCadete}
                                        cadetes={cadetes[pedido.ciudad_id]}
                                        cadete={pedido.cadete}
                                        avanzar={aConfirmado}
                                        setTimestamp={setTimestamp}
                                        modificarPedido={modificarPedido}
                                        cancelarPedido={cancelarPedido}
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>

                    {/* Completados & Cancelados Section */}
                    <Grid container className={"pedidosLabel"}>
                        <Grid item xs={12}>
                            <p>Completados: {filteredCompletados.length}  |  Cancelados: {filteredCancelados.length}</p>
                        </Grid>
                        <Grid container spacing={1}>
                            {filteredCompletados.map((pedido, key) => {
                                return (
                                    <Grid item xs={2} key={key}>
                                        <ItemCompletado pedido={pedido} />
                                    </Grid>
                                );
                            })}
                            {filteredCancelados.map((pedido, key) => {
                                return (
                                    <Grid item xs={2} key={key}>
                                        <ItemCompletado pedido={pedido} />
                                    </Grid>
                                );
                            })}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
};

export default Pedidos;
